import { Routes, Route, Navigate } from "react-router-dom";

import MainLayout from "../components/layouts/MainLayout";
import Home from "../components/pages/Home";
import About from "../components/pages/About";
import Contact from "../components/pages/Contact";
import ServicePage from "../components/helpers/ServicePage";
import FAQ from "../components/pages/FAQ";
import BrandRentalPage from "../components/helpers/BrandRentalPage";
import LocationRentalPage from "../components/helpers/LocationRentalPage"; // <-- NEW IMPORT

export default function AppRouter() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />

        {/* Redirect base /services to the first default tab */}
        <Route
          path="/services"
          element={<Navigate to="/services/car-rental-booking" replace />}
        />

        {/* Dynamic route for the services pages */}
        <Route path="/services/:serviceId" element={<ServicePage />} />

        {/* Dynamic route for Car Brands */}
        <Route
          path="/car-rental-brands/:brandId"
          element={<BrandRentalPage />}
        />

        {/* NEW: Dynamic route for Airports and Cities */}
        <Route
          path="/car-rental-locations/:locationId"
          element={<LocationRentalPage />}
        />
      </Route>
    </Routes>
  );
}
